import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().trim().email('Email inválido.').max(255),
  // No login NÃO validamos política forte — só não-vazio. Validador forte
  // é regra para criação/troca de senha. Espelha login.dto.ts da API.
  senha: z.string().min(1, 'Senha é obrigatória.').max(255),
});

export type LoginForm = z.infer<typeof loginSchema>;
